<template>
    <ClosedTradeDataTable></ClosedTradeDataTable>
</template>

<script>
import ClosedTradeDataTable from "./ClosedTradeDataTable.vue";

export default {
    components: { ClosedTradeDataTable },
}
</script>